import { handleActions } from 'redux-actions';
import { PARTITION, actionTypes, ACTION_PREFIX } from './constants';
import { getActionOptions } from '../../lib/reduxActionsUtils';
import { Account } from '../../types';

export interface ReduxState {
  accounts?: Account[];
  selectedAccount?: Account;
}

const initialState: ReduxState = {
  accounts: [],
  selectedAccount: undefined,
};

const reducer = handleActions(
  {
    [actionTypes.GET_ACCOUNTS_TO_LINK_FULFILLED]: (state: any, { payload }) => ({
      ...state,
      accounts: payload.data.accounts,
    }),
    [actionTypes.SET_SELECTED_ACCOUNT]: (state: any, { payload }) => ({
      ...state,
      selectedAccount: payload,
    }),
  },
  initialState,
  getActionOptions(ACTION_PREFIX)
);

export default {
  [PARTITION]: reducer,
};
